module.exports = __webpack_public_path__ + "static/media/karta-duzej-rodziny.c3986946.svg";